// extracted by mini-css-extract-plugin
export var animationContainer = "_dd-0";
export var asteriskIcon = "_dd-8";
export var conversationLeftSection = "_dd-4";
export var conversationListItem = "_dd-3";
export var conversationMiddleSection = "_dd-5";
export var conversationRightSection = "_dd-6";
export var detailsContent = "_dd-1";
export var listContainer = "_dd-7";
export var modalContent = "_dd-2";